/**
 *
 * @param refferedArray
 * @param data
 * @param callback
 * @returns {Array}
 */
export function create(
  refferedArray = [],
  data = {},
  callback
) {
  data.map( d => refferedArray.push(d) );
  if( callback ){
    return callback(refferedArray);
  }
  return refferedArray;
}

/**
 *
 * @param reference
 * @param data
 */
export function update(
  reference = {},
  data = {}
) {

  try{
    Object.keys(reference).map(key => {
      if( typeof reference[key] == 'object' ) {
        update(reference[key], data[key]);
      } else {
        reference[key] = data[key];
      }
    });
  } catch( e ){}

}

/**
 *
 * @param referedArray
 * @param key
 * @param value
 */
export function destroy(
  referedArray = [],
  key = String,
  value = String
) {

  referedArray.filter(( reference, iterator ) => {
    if( reference[key] === value ) {
      referedArray.splice( iterator, 1 );
    }
  } );

}





/** WEBPACK FOOTER **
 ** ./frontend/@/refference.helper.js
 **/